var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatternBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 454,
    viewBox: "0 0 454 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6402_2256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.99 0V454L0 227.01L226.99 0Z",
    fill: "#341001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 227.01L226.99 454V0L454 227.01Z",
    fill: "#481F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.99 0L0 227.01V0H226.99Z",
    fill: "#481F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 227.01V454H226.99L454 227.01Z",
    fill: "#341001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 0V227.01L226.99 0H454Z",
    fill: "#341001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.99 454H0V227.01L226.99 454Z",
    fill: "#481F0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6402_2256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 454,
    height: 454,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternBg);
export default __webpack_public_path__ + "static/media/pattern-bg.6c80ad38779371074f12f9a61e65d43d.svg";
export { ForwardRef as ReactComponent };